import { render } from "./insure-deduction.vue?vue&type=template&id=68dd4336&scoped=true&ts=true"
import script from "./insure-deduction.vue?vue&type=script&lang=ts"
export * from "./insure-deduction.vue?vue&type=script&lang=ts"

import "./insure-deduction.vue?vue&type=style&index=0&id=68dd4336&lang=stylus&scoped=true"

import exportComponent from "E:\\code\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68dd4336"]])

export default __exports__